(() => {
  const start = () => {
    const bar = document.getElementById('strik3d-mobile-purchase');
    const action = bar?.querySelector('[data-strik3d-purchase]');
    if (!bar || !action) return;
    const mobile = window.matchMedia('(max-width: 767px)');
    let ready = false;
    let nativeButton;
    const findButton = () => Array.from(document.querySelectorAll('#MainContent button')).find(button => /^add to cart$/i.test(button.textContent.trim()) && button.getBoundingClientRect().width > 0);
    const sync = () => {
      nativeButton = findButton();
      if (!nativeButton) { bar.hidden = true; return; }
      const box = nativeButton.getBoundingClientRect();
      bar.hidden = !mobile.matches || (box.top >= 0 && box.bottom <= window.innerHeight);
      action.setAttribute('aria-disabled', String(ready && (nativeButton.disabled || nativeButton.getAttribute('aria-disabled') === 'true')));
      action.textContent = ready ? action.dataset.addLabel : action.dataset.chooseLabel;
    };
    action.addEventListener('click', event => {
      nativeButton = findButton();
      if (!nativeButton) return;
      event.preventDefault();
      if (!ready) {
        ready = true;
        nativeButton.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center'});
        window.setTimeout(() => nativeButton.focus({preventScroll: true}), 350);
      } else if (!nativeButton.disabled && nativeButton.getAttribute('aria-disabled') !== 'true') {
        nativeButton.click();
      }
      sync();
    });
    document.getElementById('MainContent')?.addEventListener('change', event => {
      if (event.target.matches('select,input[type="radio"]')) ready = true;
      sync();
    });
    let scheduled = false;
    const update = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; sync(); });
    };
    window.addEventListener('scroll', update, {passive: true});
    window.addEventListener('resize', update, {passive: true});
    document.addEventListener('shopify:section:load', update);
    mobile.addEventListener('change', update);
    sync();
    window.setTimeout(sync, 1200);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();

